var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebtsOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5F50F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 13V27C29.5 28.103 28.603 29 27.5 29H12.5C11.397 29 10.5 28.103 10.5 27V13C10.5 11.897 11.397 11 12.5 11H15V9H17V11H23V9H25V11H27.5C28.603 11 29.5 11.897 29.5 13ZM12.5 16H27.5V14H12.5V16ZM16.7071 24.3639C16.3166 24.7545 16.3166 25.3876 16.7071 25.7782C17.0976 26.1687 17.7308 26.1687 18.1213 25.7782L23.7782 20.1213C24.1687 19.7308 24.1687 19.0976 23.7782 18.7071C23.3877 18.3166 22.7545 18.3166 22.364 18.7071L16.7071 24.3639ZM17.75 21C18.4404 21 19 20.4404 19 19.75C19 19.0596 18.4404 18.5 17.75 18.5C17.0596 18.5 16.5 19.0596 16.5 19.75C16.5 20.4404 17.0596 21 17.75 21ZM24 24.75C24 25.4404 23.4404 26 22.75 26C22.0596 26 21.5 25.4404 21.5 24.75C21.5 24.0596 22.0596 23.5 22.75 23.5C23.4404 23.5 24 24.0596 24 24.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtsOther);
export default __webpack_public_path__ + "static/media/debtsOther.e5d0c491e0a8040813319a0346e1a1c9.svg";
export { ForwardRef as ReactComponent };